import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import { AppDispatch, RootState } from '../../../redux/store';
import { revokeManageApiKey } from "../../../redux/actions/apiKeys.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import KeyActionModal from "../../../components/common/KeyActionModal";
import { withDefaultType } from "../params";

const RevokeManageKeyModal: React.FC<ModalProps> = ({ open, setOpen, object }) => {
  const searchParams = useSearchParams()[0];
  const dispatch = useDispatch<AppDispatch>();
  const { error, loading } = useSelector((state: RootState) => state.manageApiKeys);

  return (
    <KeyActionModal
      open={open}
      setOpen={setOpen}
      title={`Revoke API key for ${object?.spaName ?? object?.spaSerial ?? object?.spaGuid}?`}
      body="Anything using this key will stop working immediately."
      actionLabel="Revoke"
      destructive
      loadingLabel="Revoking..."
      successMessage="API key revoked."
      loading={loading}
      error={error}
      onConfirm={async () => {
        await dispatch(revokeManageApiKey({
          apikey: object?.apikey,
          params: withDefaultType(searchParams),
        }));
      }}
    />
  );
};

export default RevokeManageKeyModal;
